import React from 'react';
import { ArrowDown } from 'lucide-react';
import bannerBg from '../../assets/images/banner/banner-bg.png';
import bannerBgMob from '../../assets/images/banner/mobile-view/banner-bg-mob.png';
import bannerBorder from '../../assets/images/banner/banner-border.png';
import bannerVector from '../../assets/images/banner/banner-vector.png';
import bannerLabel from '../../assets/images/banner/banner-label.png';
import bannerLabelText from '../../assets/images/banner/banner-label-text.png';
import bannerLeftStar from '../../assets/images/banner/banner-left-star.png';
import bannerRightStar from '../../assets/images/banner/banner-right-star.png';
import bannerLeftBg from '../../assets/images/banner/banner-bg-left.png';
import bannerRightBg from '../../assets/images/banner/banner-bg-right.png';
import bannerLeftBody from '../../assets/images/banner/banner-left-body.png';
import bannerRightBody from '../../assets/images/banner/banner-right-body.png';

const Banner: React.FC = () => {
  return (
    <>
      {/* ===== DESKTOP VIEW ===== */}
      <div className="hidden md:block w-full relative overflow-hidden">
        {/* Desktop Background Image */}
        <img
          src={bannerBg}
          alt="Banner Background"
          className="w-full block max-w-full h-auto"
        />

        {/* Border at the top */}
        <img
          src={bannerBorder}
          alt="Banner Border"
          className="absolute top-0 left-0 w-full"
        />

        {/* Left Vector */}
        <img
          src={bannerVector}
          alt="Left Vector"
          className="absolute desktop-vector desktop-vector-left"
          style={{ top: '80px', left: '50px', width: '147px', height: '147px' }}
        />

        {/* Right Vector */}
        <img
          src={bannerVector}
          alt="Right Vector"
          className="absolute desktop-vector desktop-vector-right"
          style={{ top: '80px', right: '50px', width: '147px', height: '147px' }}
        />

        {/* Red Background behind "INDIA MEETS MEXICO" */}
        <div
          className="absolute desktop-red-bg"
          style={{
            top: '135px', left: '50%', transform: 'translateX(-50%)',
            width: '930px', height: '120px', maxWidth: '90%',
            backgroundColor: '#921317',
            animation: 'fadeIn 1s ease-out 0.3s both',
          }}
        />

        {/* Text Block */}
        <div
          className="absolute font-medium uppercase text-center leading-none desktop-text-block"
          style={{
            top: '137px', left: '50%', transform: 'translateX(-50%)',
            width: '1200px', maxWidth: '90%',
            fontFamily: "'Teko', sans-serif",
            animation: 'fadeSlideDown 1.2s ease-out 0.2s both',
          }}
        >
          <div className="desktop-text" style={{ fontSize: '140px', color: '#FFC600' }}>INDIA MEETS MEXICO</div>
          <div className="desktop-text" style={{ fontSize: '140px', color: '#FFFBF3' }}>IN THE HEART OF</div>
          <div className="desktop-text" style={{ fontSize: '140px', color: '#FFFBF3' }}>AUSTRALIA</div>
        </div>

        {/* Left Star Oval */}
        <div
          className="absolute desktop-left-oval"
          style={{ top: '71%', left: '16%', transform: 'translate(-50%, -50%)', animation: 'zoomIn 0.8s ease-out 1.5s both' }}
        >
          <div className="relative">
            <img src={bannerLeftBg} alt="Left Star Background" className="desktop-oval" style={{ width: '350px', height: '500px' }} />
            <img src={bannerLeftBody} alt="Left Character" className="absolute"
              style={{ top: '0', left: '0', width: '100%', height: '100%', zIndex: 1, animation: 'slideUpBody 0.8s ease-out 1.8s both' }} />
            <img src={bannerLeftStar} alt="Left Star" className="absolute desktop-star"
              style={{ top: '-22%', left: '50%', transform: 'translateX(-50%)', animation: 'spin 8s linear infinite' }} />
          </div>
        </div>

        {/* Right Star Oval */}
        <div
          className="absolute desktop-right-oval"
          style={{ top: '71%', right: '16%', transform: 'translate(50%, -50%)', animation: 'zoomInRight 0.8s ease-out 1.7s both' }}
        >
          <div className="relative">
            <img src={bannerRightBg} alt="Right Star Background" className="desktop-oval" style={{ width: '350px', height: '500px' }} />
            <img src={bannerRightBody} alt="Right Character" className="absolute"
              style={{ top: '0', left: '0', width: '100%', height: '100%', zIndex: 1, animation: 'slideUpBody 0.8s ease-out 2s both' }} />
            <img src={bannerRightStar} alt="Right Star" className="absolute desktop-star"
              style={{ top: '-22%', left: '50%', transform: 'translateX(-50%)', animation: 'spin 8s linear infinite reverse' }} />
          </div>
        </div>

        {/* Grill Me Crazy Label */}
        <div
          className="absolute label-container"
          style={{ top: '70%', left: '50%', transform: 'translate(-50%, -50%)', animation: 'slideInLabel 0.8s ease-out 0.8s both' }}
        >
          <div className="relative label-wrapper">
            <img src={bannerLabel} alt="Label Background" className="desktop-label-bg" style={{ width: '580px', height: '85px' }} />
            <img src={bannerLabelText} alt="Grill Me Crazy" className="absolute desktop-label-text"
              style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '490px', height: '55px' }} />
          </div>
        </div>

        {/* Scroll Indicator */}
        <div
          className="absolute desktop-scroll"
          style={{
            bottom: '20px', left: '50%', transform: 'translateX(-50%)',
            width: '152px', height: '47px', backgroundColor: '#FFC600', borderRadius: '24px',
            display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '6px',
            animation: 'slideUp 0.8s ease-out 2.2s both',
          }}
        >
          <span className="desktop-scroll-text" style={{ fontFamily: "'Teko', sans-serif", fontSize: '37px', color: '#026931', fontWeight: 400, paddingTop: '4px' }}>SCROLL</span>
          <div className="desktop-scroll-circle" style={{
            width: '33px', height: '33px', backgroundColor: '#EC461C', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            animation: 'bounce 1s ease-in-out infinite',
          }}>
            <ArrowDown size={24} color="#FFFFFF" strokeWidth={3} />
          </div>
        </div>
      </div>

      {/* ===== MOBILE VIEW ===== */}
      <div className="block md:hidden w-full relative overflow-hidden">
        {/* Mobile Background Image as container */}
        <img
          src={bannerBgMob}
          alt="Banner Background Mobile"
          className="w-full block"
        />

        {/* Mobile Border */}
        <img
          src={bannerBorder}
          alt="Banner Border"
          className="absolute top-0 left-0 w-full"
        />

        {/* Mobile Vectors */}
        <img src={bannerVector} alt="Left Vector" className="absolute"
          style={{ top: '40px', left: '20px', width: '60px', height: '60px', zIndex: 2 }} />
        <img src={bannerVector} alt="Right Vector" className="absolute"
          style={{ top: '40px', right: '20px', width: '60px', height: '60px', zIndex: 2 }} />

        {/* Mobile Red Background */}
        <div className="absolute" style={{
          top: '110px', left: '50%', transform: 'translateX(-50%)',
          width: '90%', height: '40px', backgroundColor: '#921317', zIndex: 2,
          animation: 'fadeIn 1s ease-out 0.3s both',
        }} />

        {/* Mobile Text Block */}
        <div
          className="absolute font-medium uppercase text-center leading-none"
          style={{
            top: '110px', left: '50%', transform: 'translateX(-50%)',
            width: '95%', fontFamily: "'Teko', sans-serif", zIndex: 2,
            animation: 'fadeSlideDown 1.2s ease-out 0.2s both',
          }}
        >
          <div style={{ fontSize: '48px', color: '#FFC600' }}>INDIA MEETS MEXICO</div>
          <div style={{ fontSize: '48px', color: '#FFFBF3' }}>IN THE HEART OF</div>
          <div style={{ fontSize: '48px', color: '#FFFBF3' }}>AUSTRALIA</div>
        </div>

        {/* Mobile Grill Me Crazy Label */}
        <div className="absolute label-container" style={{
          top: '290px', left: '50%', transform: 'translateX(-50%)', zIndex: 2, width: 'max-content', textAlign: 'center',
          animation: 'slideInLabel 0.8s ease-out 0.8s both',
        }}>
          <div className="relative label-wrapper">
            <img src={bannerLabel} alt="Label Background" style={{ width: '250px', height: '36px' }} />
            <img src={bannerLabelText} alt="Grill Me Crazy" className="absolute"
              style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '210px', height: '20px' }} />
          </div>
        </div>

        {/* Mobile Left Star Oval */}
        <div className="absolute" style={{
          top: '480px', left: '25%', transform: 'translateX(-50%)', zIndex: 2,
          animation: 'zoomIn 0.8s ease-out 1.5s both',
        }}>
          <div className="relative">
            <img src={bannerLeftBg} alt="Left Star Background" style={{ width: '145px', height: '200px' }} />
            <img src={bannerLeftBody} alt="Left Character" className="absolute"
              style={{ top: '0', left: '0', width: '100%', height: '100%', zIndex: 1, animation: 'slideUpBody 0.8s ease-out 1.8s both' }} />
            <img src={bannerLeftStar} alt="Left Star" className="absolute"
              style={{ top: '-21%', left: '50%', transform: 'translateX(-50%)', animation: 'spin 8s linear infinite' }} />
          </div>
        </div>

        {/* Mobile Right Star Oval */}
        <div className="absolute" style={{
          top: '480px', right: '25%', transform: 'translateX(50%)', zIndex: 2,
          animation: 'zoomInRight 0.8s ease-out 1.7s both',
        }}>
          <div className="relative">
            <img src={bannerRightBg} alt="Right Star Background" style={{ width: '145px', height: '200px' }} />
            <img src={bannerRightBody} alt="Right Character" className="absolute"
              style={{ top: '0', left: '0', width: '100%', height: '100%', zIndex: 1, animation: 'slideUpBody 0.8s ease-out 2s both' }} />
            <img src={bannerRightStar} alt="Right Star" className="absolute"
              style={{ top: '-21%', left: '50%', transform: 'translateX(-50%)', animation: 'spin 8s linear infinite reverse' }} />
          </div>
        </div>

        {/* Mobile Scroll Indicator */}
        <div className="absolute" style={{
          bottom: '25px', left: '50%', transform: 'translateX(-50%)',
          width: '80px', height: '35px', backgroundColor: '#FFC600', borderRadius: '20px',
          display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '4px',
          zIndex: 2, animation: 'slideUp 0.8s ease-out 2.2s both',
        }}>
          <span style={{ fontFamily: "'Teko', sans-serif", fontSize: '21px', color: '#026931', fontWeight: 400, paddingTop: '3px' }}>SCROLL</span>
          <div style={{
            width: '20px', height: '20px', backgroundColor: '#EC461C', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            animation: 'bounce 1s ease-in-out infinite',
          }}>
            <ArrowDown size={14} color="#FFFFFF" strokeWidth={3} />
          </div>
        </div>
      </div>

      {/* CSS Keyframes and Animations */}
      <style>{`
        @keyframes fadeSlideDown {
          from { opacity: 0; transform: translateX(-50%) translateY(-80px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: translate(-50%, -50%) scale(0.3); }
          to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        }
        @keyframes zoomInRight {
          from { opacity: 0; transform: translate(50%, -50%) scale(0.3); }
          to { opacity: 1; transform: translate(50%, -50%) scale(1); }
        }
        @keyframes slideInLabel {
          from { opacity: 0; transform: translate(-50%, calc(-50% + 150px)); }
          to { opacity: 1; transform: translate(-50%, -50%); }
        }
        @keyframes slideUpBody {
          0% { opacity: 0; transform: translateY(150px) scale(0.5); }
          60% { opacity: 1; transform: translateY(-10px) scale(1.05); }
          80% { transform: translateY(5px) scale(0.98); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateX(-50%) translateY(40px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
        @keyframes spin {
          from { transform: translateX(-50%) rotate(0deg); }
          to { transform: translateX(-50%) rotate(360deg); }
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        .label-container:hover .label-wrapper {
          filter: drop-shadow(0 0 20px rgba(255, 198, 0, 0.6)) brightness(1.05);
        }
        .label-wrapper {
          transition: filter 0.4s ease;
        }

        /* ===== TABLET VIEW (768px - 1023px) ===== */
        @media (min-width: 768px) and (max-width: 1023px) {
          .desktop-text { font-size: 90px !important; }
          .desktop-red-bg { width: 650px !important; height: 85px !important; top: 90px !important; }
          .desktop-text-block { top: 92px !important; width: 850px !important; }
          .desktop-vector { width: 90px !important; height: 90px !important; top: 50px !important; }
          .desktop-vector-left { left: 25px !important; }
          .desktop-vector-right { right: 25px !important; }
          .desktop-oval { width: 250px !important; height: 360px !important; }
          .desktop-left-oval { left: 18% !important; }
          .desktop-right-oval { right: 18% !important; }
          .desktop-star { width: 70px !important; height: 70px !important; }
          .desktop-label-bg { width: 400px !important; height: 58px !important; }
          .desktop-label-text { width: 340px !important; height: 38px !important; }
          .desktop-scroll { width: 120px !important; height: 40px !important; }
          .desktop-scroll-text { font-size: 30px !important; }
          .desktop-scroll-circle { width: 26px !important; height: 26px !important; }
        }

        /* ===== LAPTOP VIEW (1024px - 1279px) ===== */
        @media (min-width: 1024px) and (max-width: 1279px) {
          .desktop-text { font-size: 110px !important; }
          .desktop-red-bg { width: 780px !important; height: 100px !important; top: 110px !important; }
          .desktop-text-block { top: 112px !important; width: 1000px !important; }
          .desktop-vector { width: 110px !important; height: 110px !important; top: 60px !important; }
          .desktop-vector-left { left: 35px !important; }
          .desktop-vector-right { right: 35px !important; }
          .desktop-oval { width: 300px !important; height: 420px !important; }
          .desktop-left-oval { left: 16% !important; }
          .desktop-right-oval { right: 16% !important; }
          .desktop-star { width: 85px !important; height: 85px !important; }
          .desktop-label-bg { width: 500px !important; height: 72px !important; }
          .desktop-label-text { width: 420px !important; height: 46px !important; }
          .desktop-scroll { width: 135px !important; height: 43px !important; }
          .desktop-scroll-text { font-size: 33px !important; }
          .desktop-scroll-circle { width: 29px !important; height: 29px !important; }
        }
      `}</style>
    </>
  );
};

export default Banner;
